/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CategoryOverride } from './CategoryOverride';
import {
    CategoryOverrideFromJSON,
    CategoryOverrideFromJSONTyped,
    CategoryOverrideToJSON,
    CategoryOverrideToJSONTyped,
} from './CategoryOverride';
import type { ChannelPreference } from './ChannelPreference';
import {
    ChannelPreferenceFromJSON,
    ChannelPreferenceFromJSONTyped,
    ChannelPreferenceToJSON,
    ChannelPreferenceToJSONTyped,
} from './ChannelPreference';
import type { QuietHours } from './QuietHours';
import {
    QuietHoursFromJSON,
    QuietHoursFromJSONTyped,
    QuietHoursToJSON,
    QuietHoursToJSONTyped,
} from './QuietHours';

/**
 * 
 * @export
 * @interface ResolvedNotificationPreferences
 */
export interface ResolvedNotificationPreferences {
    /**
     * 
     * @type {{ [key: string]: ChannelPreference; }}
     * @memberof ResolvedNotificationPreferences
     */
    channels?: { [key: string]: ChannelPreference; };
    /**
     * 
     * @type {{ [key: string]: CategoryOverride; }}
     * @memberof ResolvedNotificationPreferences
     */
    categoryOverrides?: { [key: string]: CategoryOverride; };
    /**
     * 
     * @type {QuietHours}
     * @memberof ResolvedNotificationPreferences
     */
    effectiveQuietHours?: QuietHours;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ResolvedNotificationPreferences
     */
    resolutionTrace?: { [key: string]: any; };
}

/**
 * Check if a given object implements the ResolvedNotificationPreferences interface.
 */
export function instanceOfResolvedNotificationPreferences(value: object): value is ResolvedNotificationPreferences {
    return true;
}

export function ResolvedNotificationPreferencesFromJSON(json: any): ResolvedNotificationPreferences {
    return ResolvedNotificationPreferencesFromJSONTyped(json, false);
}

export function ResolvedNotificationPreferencesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResolvedNotificationPreferences {
    if (json == null) {
        return json;
    }
    return {
        
        'channels': json['channels'] == null ? undefined : (mapValues(json['channels'], ChannelPreferenceFromJSON)),
        'categoryOverrides': json['categoryOverrides'] == null ? undefined : (mapValues(json['categoryOverrides'], CategoryOverrideFromJSON)),
        'effectiveQuietHours': json['effectiveQuietHours'] == null ? undefined : QuietHoursFromJSON(json['effectiveQuietHours']),
        'resolutionTrace': json['resolutionTrace'] == null ? undefined : json['resolutionTrace'],
    };
}

export function ResolvedNotificationPreferencesToJSON(json: any): ResolvedNotificationPreferences {
    return ResolvedNotificationPreferencesToJSONTyped(json, false);
}

export function ResolvedNotificationPreferencesToJSONTyped(value?: ResolvedNotificationPreferences | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'channels': value['channels'] == null ? undefined : (mapValues(value['channels'], ChannelPreferenceToJSON)),
        'categoryOverrides': value['categoryOverrides'] == null ? undefined : (mapValues(value['categoryOverrides'], CategoryOverrideToJSON)),
        'effectiveQuietHours': QuietHoursToJSON(value['effectiveQuietHours']),
        'resolutionTrace': value['resolutionTrace'],
    };
}

